export default __webpack_public_path__ + "images/process_4.svg?4aa56ed3b2714feb358b0d9d09663d49";